const PFUtils = {
  install(Vue, options) {
    // --------------------------------------------------
    // Methods here
    // --------------------------------------------------

    Vue.prototype.$utils = {
      log: function(args) {
        var prefix = options.logPrefix || 'LOG';
        if (args && process.env.NODE_ENV !== 'production') {
          // If not an array convert to one.
          if (typeof args === 'string') {
            var tmp = args;
            args = [tmp];
          }
          console.log('# ' + prefix + ' : ' + args.join(',').replace(/,/g, ' : '));
        }
      },
      isDefined: function(val) {
        return (
          typeof val !== 'undefined' &&
          val !== undefined &&
          val !== 'undefined' &&
          val !== '' &&
          val !== null &&
          val !== 'null'
        );
      },
      stripTags: function(string) {
        return string.replace(/<([^>]+)>/gi, '');
      },
      allowBodyScroll: function() {
        var vm = this;
        console.log(`PFUtils : allowBodyScroll()`);
        var documentBody = document.querySelector('body');
        setTimeout(function() {
          vm.removeClass(documentBody, 'overflow-hidden');
        }, 0);
      },
      preventBodyScroll: function() {
        var vm = this;
        console.log(`PFUtils : preventBodyScroll()`);
        var documentBody = document.querySelector('body');
        setTimeout(function() {
          vm.addClass(documentBody, 'overflow-hidden');
        }, 0);
      },
      toPocStart: function() {
        window.location.href = process.env.VUE_APP_LAUNCHER_URL + '#/start';
      },
      // -------------------------------------------
      // DOM helpers
      // -------------------------------------------
      hasClass: function(el, className) {
        return el.classList
          ? el.classList.contains(className)
          : new RegExp('\\b' + className + '\\b').test(el.className);
      },
      addClass: function(el, className) {
        if (el.classList) el.classList.add(className);
        else if (!this.hasClass(el, className)) el.className += ' ' + className;
      },
      removeClass: function(el, className) {
        if (el.classList) el.classList.remove(className);
        else el.className = el.className.replace(new RegExp('\\b' + className + '\\b', 'g'), '');
      }
    };
  }
};

export default PFUtils;
